import React from "react";
import PropTypes from "prop-types";
import { Col, Row, Card, CardBody, Form } from "reactstrap";
import ApplicationLargeForm from "../ApplicationForm/ApplicationLargeForm/ApplicationLargeForm";
import { connect } from "react-redux";
import { getApplications } from "../../store/apps/actions";
import styled from "styled-components";
import queryString from "query-string";
import reactSelect from "react-select";

class ApplicationList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clients: [],
      filters: [
        { label: "All", value: "all" },
        { label: "Active", value: "true" },
        { label: "Inactive", value: "false" },
      ],
      selectedFilter: {},
    };
  }

  componentDidMount() {
    let dataApps = this.props.apps;
    dataApps["is_active"] = this.state.filters[1].value;
    // this.props.getApplications(dataApps);
    this.handleSelectStatus(this.state.filters[1]);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.apps !== this.props.apps) {
      this.setApplications(this.props.apps);
    }
  }

  handleSelectStatus = item => {
    let appData = this.props.apps;
    appData["is_active"] = item.value;

    this.setState({
      selectedFilter: item,
    });
    this.props.getApplications(appData);
  };

  setApplications = apps => {
    const data = [];

    for (let i in apps.results) {
      let clients = data.find(cl => cl.id === apps.results[i].client.id);

      if (clients === undefined) {
        data.push({
          id: apps.results[i].client.id,
          name: apps.results[i].client.real_name,
          apps: [apps.results[i]],
        });
      } else {
        let clientsIdx = data.findIndex(
          cl => cl.id === apps.results[i].client.id
        );
        data[clientsIdx].apps.push(apps.results[i]);
      }
    }

    this.setState({ clients: data });
  };

  render() {
    const { pathname } = this.props;
    return (
      <React.Fragment>
        <StyledRow>
          <div className="col-12">
            <StyledCard>
              <CardBody
                style={{
                  padding: "1.25rem 0",
                }}
              >
                <FilterContainer className="d-flex justify-content-between align-items-end">
                  <div>
                    <Form className="row gy-2 gx-3 align-items-center">
                      <div className="col-sm-auto">
                        <span>{"Filter by"}:</span>
                      </div>
                      <div className="col-sm-auto">
                        <CustomSelect
                          defaultValue={this.state.filters[0]}
                          value={this.state.selectedFilter}
                          onChange={this.handleSelectStatus}
                          isLoading={this.props.loading}
                          options={this.state.filters}
                          classNamePrefix="select2-selection"
                          required
                        />
                      </div>
                    </Form>
                  </div>
                </FilterContainer>
              </CardBody>
            </StyledCard>
          </div>
        </StyledRow>

        {this.state.clients.length > 0 &&
          this.state.clients.map((item, key) => (
            <Row key={key}>
              <Row>
                <h4 className="mb-3">Client {item.name} </h4>
              </Row>
              <Row>
                {item.apps.map((app, idx) => (
                  <Col sm={6} key={idx}>
                    <ApplicationLargeForm
                      image={app.app_picture}
                      app_id={app.app_id}
                      description={app.description}
                      name={app.name}
                      display_os_type={app.display_os_type}
                      app_type={app.type}
                      pathname={pathname}
                    />
                  </Col>
                ))}
              </Row>
            </Row>
          ))}
      </React.Fragment>
    );
  }
}

const CustomSelect = styled(reactSelect)`
  min-width: 240px;

  .select2-selection__control {
    &.select2-selection__control--is-focused {
      box-shadow: none !important;
      border-color: rgb(189, 195, 200) !important;

      &.select2-selection__control--menu-is-open {
        box-shadow: none !important;
        border-color: rgb(189, 195, 200) !important;
      }
    }
  }
`;

const FilterContainer = styled.div`
  flex-wrap: wrap;
  gap: 20px;

  & > div {
    flex: 1 1 300px;
  }
`;

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 4;
  position: sticky;
  top: 69px;
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: #f8f8fb;
  border-radius: 0.1px;
`;

ApplicationList.defaultProps = { pathname: "" };

ApplicationList.propTypes = {
  history: PropTypes.any,
  pathname: PropTypes.string,
  getApplications: PropTypes.func.isRequired,
  apps: PropTypes.any.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  apps: state.Apps.data,
  loading: state.Apps.loading,
});

export default connect(mapStateToProps, {
  getApplications,
})(ApplicationList);
